import { Modal } from "flowbite-react";
import { IRenter } from "../../../../../../../types/renter.type";
import { PaymentInfo, NegotiationReactivationType } from "../../../../../../../types/payment.type";
import { FormReactivationNegotiation } from "../form/FormReactivationNegotiation";
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import { createReactivationBilling } from "../../../../../../../common/services/payments.api";

type Props = {
  renter: IRenter
  payments: PaymentInfo[]
  open: boolean;
  onClosed: () => void;

}

export function ReactivationNegotiationModal(props: Props) {
  const handleCloseModal = () => { props.onClosed && props.onClosed() };
  const { notifySuccess, notifyError } = useToastContext();
  const renter = props.renter;
  const payments = props.payments;

  async function createBillingReactivation(dataToCreate: NegotiationReactivationType): Promise<{ ok: boolean, data: NegotiationReactivationType, errors?: unknown[] }> {
    try {
      const response = await createReactivationBilling(dataToCreate);
      if (response.ok) {
        notifySuccess(`Negociação de reativação criada com sucesso!`);
        return { ok: response.ok, data: response.data as unknown as NegotiationReactivationType, errors: response.errors as unknown[] };
      } else {
        notifyError(response.message as string)
        return { ok: false, data: {} as NegotiationReactivationType, errors: response.errors as unknown[] };
      }
    } catch (error) {
      console.error(error);
      return { ok: false, data: {} as NegotiationReactivationType, errors: [error] };
    }
  }


  return (
    <Modal
      size="7xl"
      className="relative dark:text-black"
      show={props.open}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header>
        <div className="flex items-center justify-start gap-3">
          <h3 className="text-black text-lg font-semibold">Negociação de Reativação</h3>
        </div>
      </Modal.Header>
      <Modal.Body>
        <FormReactivationNegotiation renter={renter} payments={payments} onSubmit={createBillingReactivation} />
      </Modal.Body>
    </Modal>
  )
}